import * as React from 'react';

import { PhotoData } from '@App/common/data/photoData'
import { CustomPhoto, PhotoListModel } from '@App/common/models'


import './photoGrid.css'

import 'react-image-lightbox/style.css'; // This only needs to be imported once in your app

// tslint:disable-next-line
// const Lightbox = require("react-images").default;
// tslint:disable-next-line
const Lightbox = require("react-image-lightbox").default;
// const Loader = () => <div className="loader">Loading...</div>

// tslint:disable-next-line:no-var-requires
const Gallery = require('react-photo-gallery').default;

export interface IPhotoGridProps {
  page: string,
  hider: () => void
}

export interface IPhotoGridState {
  isLoading: boolean
  isOpen: boolean
  // pagePhotos: PhotoListModel
  photoIndex: number
  showLoader: boolean;
}

export interface Iti {
  index: number
  margin: number
  photo: any
  custom: any
}

export default class IPhotoGrid extends React.Component<IPhotoGridProps, IPhotoGridState> {
  
  private pagePhotos: PhotoListModel;
  private photoLoadedCounter: number;
  constructor(props: IPhotoGridProps) {
    super(props);

    this.state = {
      isLoading : true,
      isOpen: false,
      photoIndex: 0,
      showLoader: false
    }

    this.openLightBox = this.openLightBox.bind(this);
    this.setIsOpenTo = this.setIsOpenTo.bind(this);
    this.increasePhotoIndex = this.increasePhotoIndex.bind(this);
    this.decreasePhotoIndex = this.decreasePhotoIndex.bind(this);
    this.closeLightbox = this.closeLightbox.bind(this);
  }

  public openLightBox(e: Event, obj: any) {
    this.setState({ isOpen: true, photoIndex: obj.index });
  }

  public setIsOpenTo(val: boolean) {
    this.setState({isOpen: val})
  }

  public decreasePhotoIndex() {
    const { photoList } = this.pagePhotos;
    const nextIndex: number = (this.state.photoIndex + photoList.length - 1) % photoList.length;

    this.setState({
      photoIndex: (nextIndex < 0) ? 0 : nextIndex,
    })
  }

  public increasePhotoIndex() {
    const { photoList } = this.pagePhotos;
    const nextIndex: number = (this.state.photoIndex + photoList.length + 1) % photoList.length;

    this.setState({
      photoIndex: (nextIndex > photoList.length) ? 0 : nextIndex,
    })
  }

  public closeLightbox(){
    this.setState({isOpen: false});
  }

  public handleLoad = () => (event: any) => {
    this.photoLoadedCounter++;
    console.log('handle loading');
    if (this.photoLoadedCounter >= this.pagePhotos.photoList.length - 1) {
      console.log('handle loaded')
      // this.setState({ isLoading: false })
        // this.props.hider();
    
        setTimeout(() => { 
        this.props.hider();
    }, 500)
    } 
  }

  public getPhotos = (): PhotoListModel => {
    let pagePhotoList: PhotoListModel = new PhotoListModel;
    for (const i of PhotoData) {
      if (i.category === this.props.page) {
        const hp:PhotoListModel = i;
        pagePhotoList = hp;
      }
    }

    let customPhotos: CustomPhoto[] = [];
    for (const i  of pagePhotoList.photoList) {
      const cimage = new CustomPhoto(i, this.handleLoad());
      customPhotos = customPhotos.concat(cimage)
    }

    pagePhotoList.customPhotoList = customPhotos;

    return pagePhotoList
  }



  public render() {
    // reset photos loaded counter
    this.photoLoadedCounter = 0;
    this.pagePhotos = this.getPhotos();
    const { customPhotoList, photoList } = this.pagePhotos;
    const { isOpen, photoIndex } = this.state;

    return (
      <div className='grid_top_spacer'>
        <div className='grid_wrapper'>

        {/* <div className={ this.state.isLoading || this.state.showLoader ? 'hidden' : 'fade-in' }> */}
        <div className='visible'>
          <Gallery photos={customPhotoList} onClick={this.openLightBox} />
            { isOpen && (
              <Lightbox 

              mainSrc={photoList[photoIndex].displaySrc}
              nextSrc={photoList[(photoIndex + 1) % photoList.length].displaySrc}
              prevSrc={photoList[(photoIndex + photoList.length - 1) % photoList.length].displaySrc}
              onCloseRequest={ this.closeLightbox }
              onMovePrevRequest={ this.decreasePhotoIndex }
              onMoveNextRequest={ this.increasePhotoIndex }
              discourageDownloads = { true }
                // images={this.props.pagePhotos.photoList}
                // images={
                //   photoList.map( (i, index) => {
                //     return ({ src: i.displaySrc, caption: i.description })
                //   } )
                // }
                // isOpen={isOpen}
                // currentImage={photoIndex}
                // onClickPrev={ this.decreasePhotoIndex }
                // onClickNext={ this.increasePhotoIndex }
                // onClose={ this.closeLightbox }
              />
            )}
          </div>
        </div>
      </div>
    );
  }
}




// WEBPACK FOOTER //
// ./src/bundles/photogrid/components/PhotoGrid.tsx